<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '岗位管理',
      search,
      api,
      afterGetDetail,
      ...table,
      ...dialog,
    }"
    @action="handleAction"
  >
  </zh-table-page>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
} from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value);
      if (!boolean) {
        callback(new Error("只为能正整数"));
      }
    };
    const state = reactive({
      search: [
        // {
        //   label: "岗位编码",
        //   placeholder: "岗位编码",
        //   value: "postCode",
        // },
        {
          label: "岗位名称",
          placeholder: "岗位名称",
          value: "postName",
        },
        {
          component: "zh-select",
          label: "岗位状态",
          placeholder: "岗位状态",
          value: "state",
          url: "postDictDataList",
          params: {
            dictType: "center_use_state",
          },
          field: {
            dictValue: "value",
            dictLabel: "label",
          },
        },
        // {
        //   component: "zh-select",
        //   label: "岗位来源",
        //   placeholder: "岗位来源",
        //   value: "postSource",
        //   options: [
        //     { label: "本系统", value: 0 },
        //     { label: "第三方系统", value: 1 },
        //   ],
        // },
      ],
      api: {
        list: "postPostPage",
        delete: "deletePostDelete",
        deleteAll: "",
        add: "postPostSave",
        edit: "postPostUpdate",
        detail: "getPost",
        path: "", //详情页面路由
      },
      table: {
        columns: [
          {
            prop: "postName",
            label: "岗位名称",
          },
          {
            prop: "showOrder",
            label: "岗位排序",
          },
          {
            prop: "postSource",
            label: "岗位来源",
            scopeFun: (scope) => scope.row.postSource?.desc ?? "--",
          },
          {
            prop: "groupName",
            label: "岗位分组",
          },
          {
            prop: "state",
            label: "岗位状态",
            scopeComponent: "common-switch",
          },
          {
            prop: "postDuty",
            label: "岗位职责",
            scopeComponent: "remark-cell",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
        ],
        rowKey: "postCode",
      },
      dialog: {
        dialogForm: [
          // {
          //   label: "岗位编码",
          //   placeholder: "请输入岗位编码",
          //   value: "postCode",
          // },
          {
            label: "岗位名称",
            placeholder: "请输入岗位名称",
            value: "postName",
          },

          {
            component: "zh-select",
            label: "岗位分组",
            placeholder: "请选择岗位分组",
            value: "groupKey",
            url: "postDictDataList",
            params: {
              dictType: "basic_post_group",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
          },
          {
            component: "zh-select",
            label: "岗位状态",
            placeholder: "请选择岗位状态",
            value: "state",
            url: "postDictDataList",
            params: {
              dictType: "center_use_state",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
          },
          {
            component: "el-input-number",
            label: "显示顺序",
            placeholder: "请输入显示顺序",
            value: "showOrder",
            defaultValue: 1,
            min: 1,
          },
          // {
          //   component: "el-input-number",
          //   label: "要求人数",
          //   placeholder: "请输入要求人数",
          //   value: "estimatedNum",
          // },
          {
            label: "岗位职责",
            placeholder: "请输入内容",
            value: "postDuty",
            type: "textarea",
            colSpan: 24,
          },
        ],
        dialogRules: {
          postName: [
            { required: true, message: "岗位名称不能为空", trigger: "blur" },
          ],
          postCode: [
            { required: true, message: "岗位编码不能为空", trigger: "blur" },
          ],
          showOrder: [
            { required: true, message: "显示顺序不能为空", trigger: "blur" },
            { validator: blurText, trigger: "change" },
          ],
          state: [
            { required: true, message: "请选择岗位状态", trigger: "blur" },
          ],
        },
      },
    });
    onMounted(() => {});

    const afterGetDetail = (form) => {
      return {
        ...form,
        state: form.state ? form.state.value : null,
      };
    };

    const handleAction = (item, type) => {
      if (type === "scope") {
        proxy
          .$confirm("是否修改岗位状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api
              .postPostUpdate({
                ...item,
              })
              .then((res) => {
                tableRef.value.handleSearch();
                proxy.$message.success("操作成功");
              });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      handleAction,
      afterGetDetail,
    };
  },
});
</script>
